/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object } from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import ProductTitle from './ProductTitle';
import ProductDivider from './ProductDivider';

const styles = (theme) => ({
    mainContainer: {
        textAlign: 'center',
        '& p': {
            paddingTop: theme.spacing(3),
            maxWidth: '90%',
            margin: `${theme.spacing(0)}px auto ${theme.spacing(2)}px`,
            [theme.breakpoints.up('sm')]: {
                fontSize: '1.125rem',
                maxWidth: '80%',
                margin: `${theme.spacing(3)}px auto ${theme.spacing(2)}px`,
            },
        },
    },
    imageContainer: {
        height: 211,
        [theme.breakpoints.down('sm')]: {
            height: 149,
        },
        '& img': {
            maxWidth: '100%',
            maxHeight: '100%',
        },
    },
});

const ProductOurStory = ({ classes }) => {
    const ourStory = [
        {
            label: 'Based in New York',
            icon: 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/bltd215e5dd185bceae/63748fdaed757210a08916dc/based-in-new-york.png',
        },
        {
            label: '40 years of plant experience',
            icon: 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/blt80afe9baee4ccefe/63749030da728110eb03b1d9/40years.png',
        },
        {
            label: 'Collaborating with growers across the country',
            icon: 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/blt39a55e698389818d/6374905e3688e51128bd3ff0/growers.png',
        },
        {
            label: 'Straight from the greenhouse to your door',
            icon: 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/blt846de76b1b60ca7e/6374908aa3fffc10b9dc27ba/greenhouse-door.png',
        },
    ];

    return (
        <Grid container className={classes.mainContainer}>
            <Grid item xs={12}>
                <ProductTitle title="Our Story" />
            </Grid>
            {
                ourStory.map((item) => (
                    <Grid item xs={6} sm>
                        <div className={classes.imageContainer}>
                            <img src={item.icon} alt={item.label} style={item.style} />
                        </div>
                        <p>{item.label}</p>
                    </Grid>
                ))
            }
            <ProductDivider />
        </Grid>
    );
};

ProductOurStory.propTypes = {
    classes: object.isRequired,
};

export default withStyles(styles)(ProductOurStory);
